
import { defineComponent } from "vue";
import InputField from "@/views/shared/form-parts/InputField.vue";
import PullDownSelect, {
  SelectOptions,
} from "@/views/shared/form-parts/PullDownSelect.vue";
import { string } from "yup";
import Utility from "@/assets/common/scripts/utility";

import {
  AreaList,
  CountryList,
} from "@/views/order-form/order-form-interfaces";

const MAX_COUNTRY_SELECT_FORMS = 4;
const FORM_DATA_DEFAULT = { area: "", country: "" };

interface countrySelectForm {
  key: number;
  areaInputName: string;
  countryInputName: string;
  isAreaSelected: boolean;
  countryOptions: SelectOptions[];
}

export default defineComponent({
  name: "AreaSelect",
  components: {
    InputField,
    PullDownSelect,
  },
  props: {
    areaList: {
      type: Array as () => AreaList[],
      default: () => [],
    },
    countryList: {
      type: Array as () => CountryList[],
      default: () => [],
    },
  },
  watch: {
    "formStatus.formIndexNum": function (newVal, oldVal) {
      if (newVal > oldVal) {
        this.formData.push({ ...FORM_DATA_DEFAULT });
        return;
      }
      this.formData.pop();
    },
    formData: {
      handler: "onUpdateCountries",
      deep: true,
    },
  },
  data() {
    return {
      formData: [{ ...FORM_DATA_DEFAULT }],
      formStatus: {
        formIndexNum: 1,
      },
      validRules: {
        area: string().required("エリアを選択してください"),
        country: string().required("国と地域を選択してください"),
      },
    };
  },
  computed: {
    constants(): object {
      return {
        maxAreaForms: MAX_COUNTRY_SELECT_FORMS,
      };
    },
    countrySelectForms(): countrySelectForm[] {
      return Array(this.formStatus.formIndexNum)
        .fill({})
        .map((elm: countrySelectForm, index): countrySelectForm => {
          return {
            key: index,
            areaInputName: "area_name" + index,
            countryInputName: "country_name" + index,
            isAreaSelected: this.formData[index].area !== "",
            countryOptions: Utility.getFilteredCountryOptions(
              this.formData[index].area,
              this.countryList
            ),
          };
        });
    },
    areaSelectOptions(): SelectOptions[] {
      const areaList = this.areaList;
      if (!areaList && !Array.isArray(areaList)) return [];
      return Utility.getAreaSelectOptions(this.areaList);
    },
  },
  methods: {
    addAreaSelectForm(): void {
      this.formStatus.formIndexNum++;
    },
    removeAreaSelectForm(): void {
      this.formStatus.formIndexNum--;
    },
    getSelectedCountriesArray(): string[] {
      return this.formData
        .filter((form) => form.country !== "")
        .map((form) => form.country);
    },
    onUpdateCountries(): void {
      this.$emit("updateCountries", this.getSelectedCountriesArray());
    },
  },
  emits: ["updateCountries"],
});
